import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { installmentStatus } from '../../../common/enums';
import { apiCallIds } from '../api';
import { fetchInstallmentsActions, selectInstallmentsForAllocation } from '../ducks';
import { Calendar } from '../../../common/components/data-display';
import Spin from 'antd/lib/spin';
import { MajakIcon } from '../../../common/components';

const getFirstUnpaidInstallment = (installments) =>
  installments.find(i => i.status === installmentStatus.UNPAID);

const mapStateToProps = (state, ownProps) => ({
  installments: selectInstallmentsForAllocation(state, ownProps.allocationId),
  isFetching: selectIsInProgress(state, apiCallIds.FETCH_INSTALLMENTS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchInstallments: fetchInstallmentsActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
class CalendarContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    allocationId: PropTypes.string.isRequired,
    installments: PropTypes.array,
    actions: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    toggleCalendar: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!this.props.installments) {
      this.props.actions.fetchInstallments({ allocationId: this.props.allocationId});
    }
  }

  render() {
    const { t, installments, isFetching, toggleCalendar } = this.props;

    if (isFetching && !installments) {
      return (
        <div className='text-center'>
          <Spin spinning={isFetching}></Spin>
        </div>
      )
    }

    if (!installments || installments.length === 0) {
      return null;
    }
    
    const firstUnpaidInstallment = getFirstUnpaidInstallment(installments);

    return (
      <div className="documents-panel-wrapper">
        <div className="panel-header">
          <h3>{t('Splátkový kalendár')}</h3>
          <MajakIcon onClick={toggleCalendar} type="zavriet" />
        </div>
        <Calendar
          installments={installments}
          firstUnpaidInstallment={firstUnpaidInstallment}
          renderSmall={true}
        />
      </div>
    )
  }
}

export default (translate()(CalendarContainer));



// WEBPACK FOOTER //
// ./src/features/allocations/containers/CalendarContainer.js